module.exports = __webpack_public_path__ + "static/media/banner_SicBo-Jili-half.966c18f1.png";